import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_PINCODEAREA_FAILURE,
  CREATE_PINCODEAREA_REQUEST,
  GET_ALL_PINCODEAREA_SUCCESS,
  GET_ALL_PINCODEAREA_REQUEST,
  GET_ALL_PINCODEAREA_FAILURE,
  DELETE_PINCODEAREA_REQUEST,
  DELETE_PINCODEAREA_FAILURE,
  UPDATE_PINCODEAREA_REQUEST,
  UPDATE_PINCODEAREA_FAILURE,
  DELETE_PINCODEAREA_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllPinCodeArea = () => async (dispatch) => {
  dispatch({ type: GET_ALL_PINCODEAREA_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/masterPinCodes`);
    dispatch({ type: GET_ALL_PINCODEAREA_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_PINCODEAREA_FAILURE, payload: error.message });
  }
};

export const createPinCodeArea = (masterPinCodeData) => async (dispatch) => {
  dispatch({ type: CREATE_PINCODEAREA_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/masterPinCode`, masterPinCodeData);
    if (data.status === "SUCCESS") {
      dispatch(getAllPinCodeArea());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_PINCODEAREA_FAILURE, payload: error.message });
  }
};

export const updatePinCodeArea = (masterPinCodeId, masterPinCodeData) => async (dispatch) => {
  dispatch({ type: UPDATE_PINCODEAREA_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/masterPinCode/${masterPinCodeId}`,
      masterPinCodeData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllPinCodeArea());
      toast.success("PinCodeArea Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_PINCODEAREA_FAILURE, payload: error.message });
  }
};

export const deletePinCodeArea = (masterPinCodeId) => async (dispatch) => {
  dispatch({ type: DELETE_PINCODEAREA_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/masterPinCode/${masterPinCodeId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_PINCODEAREA_SUCCESS, payload: masterPinCodeId })
      dispatch(getAllPinCodeArea());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_PINCODEAREA_FAILURE, payload: error.message });
  }
};
